import type { RootState } from "StoreTypes";
import type { FacilityNormalized } from "EntityTypes";
import type { FacilitySettings } from "Models";

export const getCurrentFacilityId = (state: RootState): string =>
  state.facility.currentFacilityId;

export const getCurrentFacility = (
  state: RootState,
): FacilityNormalized | undefined =>
  state.entities.facilities?.[state.facility.currentFacilityId];

export const getFacilityById = (
  state: RootState,
  { facilityId }: { facilityId: string },
) => state.entities.facilities?.[facilityId];

export const getCurrentFacilitySettings = (
  state: RootState,
): FacilitySettings | undefined =>
  state.entities.facilities?.[state.facility.currentFacilityId]?.settings;
